import { inject } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { InjectApp, InjectTranslate } from '../app/app';
import { PassengerDetail } from './passenger-detail';

type InjectedProps = InjectApp & InjectTranslate;

export class PassengerDetailListInner extends React.Component<InjectedProps> {
  public render() {
    const { t } = this.props;
    const { passengers } = this.props.app.booking;

    return (
      <div className="passenger-detail-list">
        <div className="container">
          <h1>{t('flight_info.passenger_details.header')}</h1>
          <p>{t('flight_info.passenger_details.text')}</p>
        </div>
        <ul className="passenger-list">
          {passengers.map((passenger) => (
            <PassengerDetail key={passenger.id} passenger={passenger} />
          ))}
        </ul>
      </div>
    );
  }
}

export const PassengerDetailList: React.ComponentClass = withRouter(
  inject('app', 't')(PassengerDetailListInner),
);



// WEBPACK FOOTER //
// ../node_modules/source-map-loader!./src/components/segment/passenger-detail-list.tsx